export interface Company {
  name: string
  tagline: string
  href: string
  domain: string
  externalUrl?: string
  color: string
  flagship?: boolean
  description: string
}

export const companies: Company[] = [
  {
    name: "Connexr",
    tagline: "Enterprise AI & Managed Services",
    href: "/companies/connexr",
    domain: "connexr.com",
    externalUrl: "https://connexr.com",
    color: "#1C2B6E",
    flagship: true,
    description:
      "RSA Tech Group's flagship enterprise AI and managed services company. Connexr delivers intelligent managed services, AIOps, AI transformation, and cloud infrastructure solutions for mid-market and Fortune 500 enterprises across 9 industries.",
  },
  {
    name: "LeoRix AI",
    tagline: "Enterprise AI Brain",
    href: "/leorix-ai",
    domain: "leorix.com",
    externalUrl: "https://leorix.com",
    color: "#7C3AED",
    description:
      "Autonomous enterprise intelligence that orchestrates your data, decisions, and digital workforce — connecting CRM, ERP, and every data silo into one AI-powered command center.",
  },
]
